export default __webpack_public_path__ + "static/media/mors_orless.9d7fa78f.jpg";